import { render, staticRenderFns } from "./SelectExamModal.vue?vue&type=template&id=09527828&scoped=true&"
import script from "./SelectExamModal.vue?vue&type=script&lang=js&"
export * from "./SelectExamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09527828",
  null
  
)

export default component.exports